import type { ToastPosition } from './toastTypes';

/**
 * Position styles
 */
export const positionStyles: Record<ToastPosition, string> = {
  'top-right': 'top-4 right-4',
  'top-left': 'top-4 left-4',
  'top-center': 'top-4 left-1/2 -translate-x-1/2',
  'bottom-right': 'bottom-4 right-4',
  'bottom-left': 'bottom-4 left-4',
  'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2',
};

/**
 * Animation variants based on position
 */
export const getAnimationVariants = (position: ToastPosition) => {
  const isTop = position.startsWith('top');
  const isRight = position.includes('right');
  const isLeft = position.includes('left');

  return {
    initial: {
      opacity: 0,
      y: isTop ? -20 : 20,
      x: isRight ? 20 : isLeft ? -20 : 0,
      scale: 0.95,
    },
    animate: {
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1,
      transition: {
        type: 'spring' as const,
        stiffness: 350,
        damping: 25,
      },
    },
    exit: {
      opacity: 0,
      scale: 0.95,
      x: isRight ? 50 : isLeft ? -50 : 0,
      transition: { duration: 0.2 },
    },
  };
};
